(function () {
  var root = document.querySelector('[data-shop]'); if (!root) return;
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var state = { group: 'all', girl: 'all' };
  function apply(scroll) {
    $$('[data-group-filter]').forEach(function (x) { if (x.classList.contains('shop__pill')) x.classList.toggle('is-on', x.getAttribute('data-group-filter') === state.group); });
    $$('[data-girl-filter]').forEach(function (x) { x.classList.toggle('is-on', x.getAttribute('data-girl-filter') === state.girl); });
    $$('.shop__card').forEach(function (c) { c.hidden = state.girl !== 'all' && c.getAttribute('data-girl') !== state.girl; });
    var first = null;
    $$('[data-group]').forEach(function (g) {
      var name = g.getAttribute('data-group');
      var show = state.group === 'all' || state.group === name;
      if (show && (name === 'triple' || name === 'double') && !g.querySelector('.shop__card:not([hidden])')) show = false;
      g.hidden = !show; if (show && !first) first = g;
    });
    if (scroll && first) { var y = first.getBoundingClientRect().top + window.pageYOffset - 110; window.scrollTo({ top: y, behavior: 'smooth' }); }
  }
  root.addEventListener('click', function (e) {
    var gf = e.target.closest('[data-group-filter]'); if (gf) { state.group = gf.getAttribute('data-group-filter'); apply(true); return; }
    var c = e.target.closest('[data-girl-filter]'); if (c) { state.girl = c.getAttribute('data-girl-filter'); apply(true); }
  });
})();
